import { sendNoContent } from 'h3';
import { getPublicPageLastModifiedHeaders, isPublicPageNotModified } from '~/utils/httpSeo';

export function usePublicPageLastModified(lastModified: string | null | undefined) {
  if (!import.meta.server) return;

  const lastModifiedHeader = getPublicPageLastModifiedHeaders(lastModified)['Last-Modified'];

  if (lastModifiedHeader) {
    const responseHeader = useResponseHeader('Last-Modified');
    responseHeader.value = lastModifiedHeader;
  }

  const event = useRequestEvent();
  const ifModifiedSince = useRequestHeader('if-modified-since');

  if (event && isPublicPageNotModified(lastModified, ifModifiedSince)) {
    sendNoContent(event, 304);
  }
}
